import React, { useState } from 'react';
import { StarIcon } from 'lucide-react';
import { Accordion } from './Accordion';
const MAX_CHARS = 300;
const inputClass = 'w-full rounded-xl border border-line bg-white px-4 py-3 font-sans text-[16px] text-ink placeholder:text-muted/70 focus:border-coral focus:outline-none';
export function ReviewForm() {
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitted(true);
  };
  return <Accordion id="review-form" className="bg-cream" openClassName="bg-cream" header={<span className="flex items-center gap-2" data-id="element-112" data-mp="6p16t94pr754">
          <StarIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-coral" fill="currentColor" strokeWidth={0} data-id="element-113" data-mp="3f5m6u0fdapw3" />
          <span className="font-sans text-[15px] font-bold leading-snug text-ink" data-id="element-114" data-mp="3b3hjfjfiiphw">
            ¿Ya lo tenés? Dejá tu reseña
          </span>
        </span>} data-id="element-111" data-mp="bivoy84o7e23">
      {submitted ? <p role="status" className="rounded-xl border border-coral/30 bg-white px-4 py-4 text-center font-sans text-[15px] text-ink" data-id="element-115" data-mp="3m5mddlkonma3">
          ¡Gracias! Tu reseña será publicada pronto.
        </p> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-116" data-mp="3vvpds6u4w2ig">
          <div data-id="element-117" data-mp="3vuxjr0g6qcua">
            <label htmlFor="review-name" className="mb-1.5 block font-sans text-[14px] text-ink-soft" data-id="element-118" data-mp="3vxs7b0uhwdrx">
              Nombre
            </label>
            <input id="review-name" type="text" required value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre" className={inputClass} data-id="element-119" data-mp="3368gaurnpvfd" />
          </div>
          <div data-id="element-120" data-mp="3d57ne8wrxj09">
            <label htmlFor="review-city" className="mb-1.5 block font-sans text-[14px] text-ink-soft" data-id="element-121" data-mp="3d5qzh8zqtd6d">
              Ciudad
            </label>
            <input id="review-city" type="text" required value={city} onChange={e => setCity(e.target.value)} placeholder="Tu ciudad" className={inputClass} data-id="element-122" data-mp="nfm7o5io6lw8" />
          </div>
          <fieldset data-id="element-123" data-mp="2oh2ai0bq3kql">
            <legend className="mb-1.5 font-sans text-[14px] text-ink-soft" data-id="element-124" data-mp="2ogk5ofazvy72">
              Tu puntuación
            </legend>
            <div className="flex items-center gap-1" data-id="element-125" data-mp="2jleh18q7k5fa">
              {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" aria-label={`${star} estrella${star > 1 ? 's' : ''}`} aria-pressed={rating === star} onClick={() => setRating(star)} className="rounded-md p-1 transition-transform duration-100 ease-out active:scale-90" data-id="element-126" data-mp="2xgpb4jwmomil">
                  <StarIcon aria-hidden="true" className={`h-7 w-7 ${star <= rating ? 'text-coral' : 'text-ink/20'}`} fill={star <= rating ? 'currentColor' : 'none'} strokeWidth={1.5} data-id="element-127" data-mp="20tbz7u1tyj3g" />
                </button>)}
            </div>
          </fieldset>
          <div data-id="element-128" data-mp="29r4e4x3n3oqb">
            <label htmlFor="review-comment" className="mb-1.5 block font-sans text-[14px] text-ink-soft" data-id="element-129" data-mp="1m3mu5nqm9uxw">
              Comentario
            </label>
            <textarea id="review-comment" required rows={4} maxLength={MAX_CHARS} value={comment} onChange={e => setComment(e.target.value)} placeholder="Contanos tu experiencia con el libro" className={`${inputClass} resize-none`} data-id="element-130" data-mp="1i19oezbvdx14" />
            <p className="mt-1 text-right font-sans text-[13px] text-muted" data-id="element-131" data-mp="1cqxfwqbkipyx">
              {comment.length}/{MAX_CHARS}
            </p>
          </div>
          <button type="submit" className="min-h-[56px] w-full rounded-full border border-coral/40 bg-white px-5 py-4 font-sans text-[16px] font-bold text-coral transition-colors duration-150 ease-out hover:border-coral hover:bg-coral-soft/50 active:scale-[0.98]" data-id="element-132" data-mp="1302vzslso2gn">
            Publicar reseña
          </button>
        </form>}
    </Accordion>;
}